import DropdownMenu from './_dropdown_menu';
import {DropdownMenuConstants} from '../modules/constants/dropdown_menu';

const MonitorsToolbar = ({handleTypeFilterClick, handleUserFilterClick, handleSortByClick, selections}, context) => {
  return (
    <div className="toolbar">
      <div className="toolbar_left">
        {null}
      </div>
      <div className="toolbar_right">
        <DropdownMenu
          id="typeFilterDropdown"
          values={[
            ['ALL', 'All'],
            ['HIGHLIGHTS', 'Highlights'],
            ['FULLPAGE', 'Full page']
          ]}
          label="Type:"
          title="Monitor type"
          selectCallback={handleTypeFilterClick}
          selectedValue={selections.typeFilterDropdown} />
        <DropdownMenu
          id="userFilterDropdown"
          values={[
            [DropdownMenuConstants.MONITORED_PAGES_FILTER_SHOW_EVERYONE, 'Everyone\'s'],
            [context.utils.user.id, 'Only mine']
          ]}
          label="View:"
          title="Filter by user"
          selectCallback={handleUserFilterClick}
          selectedValue={selections.userFilterDropdown} />
        <DropdownMenu
          id="sortByDropdown"
          values={[
            ['CHANGED', 'Last change'],
            ['CREATED', 'Creation date']
          ]}
          label="Sort by:"
          title="Sort by"
          selectCallback={handleSortByClick}
          selectedValue={selections.sortByDropdown} />
      </div>
    </div>
  );
};

MonitorsToolbar.contextTypes = {
  utils: PropTypes.object.isRequired
};

MonitorsToolbar.propTypes = {
  handleTypeFilterClick: PropTypes.func,
  handleUserFilterClick: PropTypes.func,
  handleSortByClick: PropTypes.func,
  selections: PropTypes.object
};

MonitorsToolbar.defaultProps = {
  handleTypeFilterClick() {},
  handleUserFilterClick() {},
  handleSortByClick() {},
  selections: {}
};

export default MonitorsToolbar;
